import { makeAutoObservable } from "mobx";
import SearchState from "../../SearchState";
/** @typedef {import("../../../sql/schemaDatatypes").SavedPlaylistSql} SavedPlaylistSql */

export default class AddToPlaylistState {
  /** @type {SearchState} */
  searchState;

  /** @type {Array<SavedPlaylistSql>} */
  existingSearches = [];

  /** @type {string} */
  filterSavedTerm = "";

  showingNewPlaylist = false;

  showingPlaylistPopup = false;

  /**
   * @param {SearchState} searchState
   */
  constructor(searchState) {
    makeAutoObservable(this, {}, { enforceActions: "observed" });
    this.searchState = searchState;
    this.existingSearches =
      this.searchState.myAccountState.savedTracksOrganized();
  }

  close = () => {
    this.showingNewPlaylist = false;
    this.searchState.hidePlaylistPopup();
  };

  showPlaylistPopup = () => {
    this.showingPlaylistPopup = false;
  };

  toggleShowingNewPlaylist = () => {
    console.log(this.showingNewPlaylist);
    this.showingNewPlaylist = !this.showingNewPlaylist;
    console.log(this.showingNewPlaylist);
  };

  getExistingSearches = () => {
    this.existingSearches =
      this.searchState.myAccountState.savedTracksOrganized();
    return this.existingSearches;
  };

  /**
   * @param {string} term
   * @action
   */
  filterPlaylists = (term) => {
    this.filterSavedTerm = term;
  };

  /**
   * @param {SavedPlaylistSql} playlist
   * @action
   */
  addToExistingSearch = (playlist) => {
    this.searchState.myAccountState.addTrackToPlaylist(playlist, [
      this.searchState.idToAddToPlaylist.toString(),
    ]);
  };
}
